module.exports = __webpack_public_path__ + "img/MariaDB.e1a1d31.svg";